export const constants = {
    /**
     * Settings
     * @property town       - 
     * @property ChatGPT       - 
     */
    Settings: {
        "town": "town",
        "ChatGPT": "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"
    }
};
export const routes = {
    "Screen1": "Screen1",
    "Screen3": "screen3",
    "Screen4": "screen4",
    "Screen2A_backup": "screen2a_backup",
    "Screen2A": "screen2a",
    "Screen2_backup": "screen2_backup",
    "Screen2B": "screen2b",
    "About_Us1": "about_us1",
    "Privacy_Policy": "privacy_policy",
    "Terms_of_Service": "terms_of_service",
    "Screen5": "screen5",
    "Launch": "launch",
};
export const pushSettings = {
    appID: '308e473e-e51a-4014-9ffd-6872b950db5d',
    baseUrl: 'https://api.appery.io/rest/push/reg',
    baseSendUrl: 'https://api.appery.io/rest/push/msg',
    initOptions: {}
};
export const projectInfo = {
    guid: "308e473e-e51a-4014-9ffd-6872b950db5d",
    name: "Cape Beach Info",
    description: ""
};
export const pwaInfo = {
    name: 'Redux',
    shortName: 'Redux',
    description: '',
    icon: ''
};
export const IGNORED_VALUE = Symbol.for("AIO_REST_IGNORED_VALUE");
export const apiHost = "https://api.appery.io";
export const defaultProxy = "4fdbbfb0-3579-49fb-87ac-165b669e7be1";